import {PATIENT_RECALL_SELECTED_CATEGORY} from '../actions/Index';

// Defining the initial state for the reducer
let initState = {
  selectedCategoryId: []
};

export default function (state = initState, action: any): any {
  const {type, payload} = action;

  initState = state;

  switch (type) {
    case PATIENT_RECALL_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategoryId: payload.selectedCategoryId
      };
    default:
      return state;
  }
}
